import { PANELS } from "@/admin/catalog";
import type { ConfirmTarget } from "@/components/admin/confirmChange";

/**
 * Name and risk of a panel action, taken from the catalog so the confirm
 * modal never carries its own copy. A `confirm: true` entry without a risk
 * still confirms (caution), because `risk: "none"` would skip the modal.
 */
export function panelTarget(id: string): ConfirmTarget {
  const entry = PANELS.find((p) => p.id === id);
  if (!entry) throw new Error(`Unknown panel: ${id}`);
  return { name: entry.name, risk: entry.risk && entry.risk !== "none" ? entry.risk : "caution" };
}
